import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
} from 'app/enums/common.enums'
import {
    FxRateType,
} from 'app/enums/label.enums'
import {
    FxRateFields,
} from './FxRate.types'

const config: SkyNetTableConfig<FxRateFields> = {
    name: 'FxRatesTable',
    tabs: [{
        name: 'FxRates',
        url: 'all',
        fields: [
            {
                name: 'ccyFrom',
                reduced: true,
                filterType: FilterType.Array,
                filterField: 'ccyFrom',
                labelKey: 'CURRENCY_FROM',
            },
            {
                name: 'ccyTo',
                reduced: true,
                filterType: FilterType.Array,
                filterField: 'ccyTo',
                labelKey: 'CURRENCY_TO',
            },
            {
                name: 'exchangeRate',
                labelKey: 'FX_RATE',
            },
            {
                name: 'fxRateType',
                filterField: 'fxRateType',
                fxRateType: 'array',
                componentName: 'EnumValue',
                allowedValuesEnum: FxRateType,
                labelKey: 'FX_RATE_TYPE',
            },
            {
                name: 'validFrom',
                reduced: true,
                componentName: 'DateTimeCell',
                labelKey: 'VALID_FROM',
            },
            {
                name: 'validTo',
                reduced: true,
                componentName: 'DateTimeCell',
                labelKey: 'VALID_TO',
            },
        ],
    }],
}

export default config
